import {type UploadedCustomerMessageFile} from '@dms/shared';

import {PDF_MIME_TYPE} from 'shared/web';

interface PdfEmailAttachmentFile {
  fileId: string;
  fileName: string;
  fileUrl: string;
}

export const getPdfEmailAttachment = (
  file: PdfEmailAttachmentFile
): UploadedCustomerMessageFile => ({
  fileId: file.fileId,
  fileName: file.fileName,
  fileType: PDF_MIME_TYPE,
  fileUrl: file.fileUrl,
  shouldConvertToPdf: false,
});
